// Vendor Packages
import Vue from 'vue';
import Vuex from 'vuex';
import getters from './getters';
import actions from './actions';
import mutations from './mutations';
import modules from './modules';

Vue.use(Vuex);

export const store = new Vuex.Store({
	state: {
		bodyClass: 'index-page',
		showLoader: false,
		currentPageTitle: ''
	},

	getters,
	actions,
	mutations,
	modules
});


// WEBPACK FOOTER //
// ./src/store/index.js